import React from "react"



const SearchCities=(props)=>{

return(
    <div
    className={"apInputText"}
    style={{ width: "32%", marginTop: "20px" }}
    >
    <label htmlFor="search">Пошук за назвою (серед знайдених в радіусі пошуку)</label>
    <input
    onChange={props.searchChange}
    id="search"
    type="text"
    />
    </div>
)
}

export default SearchCities;